import { Row, Typography } from 'antd';
import { useEffect, useRef, useState, VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Latitude, Longitude } from '@enmon/commons/lib/enmon';
import { Nullable } from '@enmon/commons';
import { theme } from '../../../consts/themeBase';
import { MapTab as messages } from '../messages';

interface MapTabProps {
  meterLat: Nullable<Latitude>;
  meterLng: Nullable<Longitude>;
}

export const MapTab: VFC<MapTabProps> = ({ meterLat, meterLng }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (ref.current && !map && meterLat && meterLng) {
      const newMap = new window.google.maps.Map(ref.current, {
        center: { lat: meterLat, lng: meterLng },
        fullscreenControl: false,
        zoom: 14,
        streetViewControl: false,
      });
      /* eslint-disable no-new */
      new google.maps.Marker({
        position: { lat: meterLat, lng: meterLng },
        map: newMap,
      });
      setMap(newMap);
    }
  }, [map, ref, meterLat, meterLng]);

  return (
    <>
      {meterLat && meterLng ? (
        <div>
          <div ref={ref} style={{ height: '70vh' }} />
        </div>
      ) : (
        <Row justify="space-around">
          <Typography.Paragraph style={{ fontSize: 16, color: theme.colors.dark }}>
            <FormattedMessage {...messages.mapNotAvailable} />
          </Typography.Paragraph>
        </Row>
      )}
    </>
  );
};
